export default __webpack_public_path__ + "static/media/tiktok.3d15b02c.png";